<template>
    <InterstatePriceForm :isCreate="true" />
</template>

<script setup>
import InterstatePriceForm from './InterstatePriceForm.vue';
</script>
